import axios from 'axios';

const axiosInstance = axios.create({
  // baseURL: 'http://localhost:8000', 
  baseURL: 'https://kspdata.in',
  withCredentials: true, // THIS IS CRITICAL
});

axiosInstance.interceptors.request.use(config => {
  const token = getCookie('XSRF-TOKEN');
  if (token) {
    config.headers['X-XSRF-TOKEN'] = decodeURIComponent(token);
  }
  return config;
});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export default axiosInstance;
